/**
 * Rate-cards selectors (PX-W6.4). Trivial views stay plain; nothing derived
 * is computed beyond what the server already returned.
 */

import type { RateCard } from './types'
import type { RateCardsState } from './slices/rateCardsSlice'

interface WithRateCards {
  rateCards: RateCardsState
}

export const selectRateCards = (s: WithRateCards): RateCard[] => s.rateCards.cards
export const selectRateCardsLoading = (s: WithRateCards): boolean => s.rateCards.cache.loading
export const selectRateCardsError = (s: WithRateCards) => s.rateCards.error
export const selectRateCardsMutating = (s: WithRateCards): boolean => s.rateCards.mutating
